import { render } from "./ChamCongNhanVien.vue?vue&type=template&id=39672665&scoped=true"
import script from "./ChamCongNhanVien.vue?vue&type=script&lang=js"
export * from "./ChamCongNhanVien.vue?vue&type=script&lang=js"

import "./ChamCongNhanVien.vue?vue&type=style&index=0&id=39672665&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39672665"]])

export default __exports__